import { FC } from 'react'
import { ActivateButton } from './ActivationButton.styles'
import { ActivationButtonProps } from './ActivationButton.types'
import Typography from '../typography'
import { useCustomTheme } from '@/core/theme'
import ArrowIcon from '@/assets/images/activation-arrow-icon.svg?react'

const ActivationButton: FC<ActivationButtonProps> = ({ onClick, text, id }) => {
    const theme: any = useCustomTheme()

    return (
        <ActivateButton onClick={onClick} data-testid={`activation-button-${id}`}>
            <Typography
                variant="xs-regular"
                color={theme.colors.semantic.activationButton}
                className="text"
            >
                {text}
            </Typography>
            <ArrowIcon color={theme.colors.semantic.activationButton} />
        </ActivateButton>
    )
}

export default ActivationButton
